import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Icon,
  Button,
  Checkbox,
  TextField,
  FormHelperText,
  Box,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "./FieldWorkers.css";
import { selectWorkerZone } from "../../redux/reducers/fieldMembers";
import Translate from "../Translate/Translate";
import { useAuth0 } from "@auth0/auth0-react";
import { CheckCircle, Cancel } from "@mui/icons-material";
import {
  fetchVillageCountDetailsSuccess,
  setSelectMinMaxOfSize,
  fetchSelectedVillages,
} from "../../redux/reducers/villageCount";
import { manipulateVerticalSidebar } from "../../redux/reducers/verticalSidebarV2";
import { setApplicationLoading } from "../../redux/reducers/application";
import helperFunctions from "../../utils/helper";
import { ArrowDown, ArrowUp } from "lucide-react";

const TableComponent = () => {
  const minSize = process.env.REACT_APP_MIN_SIZE;
  const maxSize = process.env.REACT_APP_MAX_SIZE;
  const selectAllOptions = process.env.REACT_APP_ALL_SELECT_OPTION;
  let tableData = useSelector((state) => state.villageCount.data || {});
  const sizeMinMaxArray = useSelector(
    (state) => state.villageCount.selectMinMaxOfSize
  );
  const siteGlobalMinVal = sizeMinMaxArray[0];
  const siteGlobalMaxVal = sizeMinMaxArray[1];
  const lpGlobalMinVal = sizeMinMaxArray[2];
  const lpGlobalMaxVal = sizeMinMaxArray[3];
  console.log(
    "url args ",
    siteGlobalMinVal,
    siteGlobalMaxVal,
    lpGlobalMinVal,
    lpGlobalMaxVal
  );
  const selectedWorkersZone = useSelector(
    (state) => state.fieldMembers.selectedWorkerZone
  );
  console.log("selectedWorkersZone ", selectedWorkersZone);

  const user = useSelector((state) => state.user);
  const zones = useSelector((state) => state.fieldMembers.workerZone); // Assuming 'tableData' is stored in the Redux store
  const verticalSidebar = useSelector((state) => state.verticalSidebarV2);

  const dispatch = useDispatch();

  const [zonesDropdownVisibility, setZonesDropdownVisibility] = useState(false);
  const [siteSizeVisibility, setSiteSizeVisibility] = useState(false);
  console.log("siteSizeVisibility ", siteSizeVisibility);
  const [landParcelSizeVisibility, setLandParcelSizeVisibility] =
    useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [selectedVillages, setSelectedVillages] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [error, setError] = useState("");
  const [minSiteSizeValue, setMinSiteSizeValue] = useState("");
  const [maxSiteSizeValue, setMaxSiteSizeValue] = useState("");
  const [isToggledForSite, setIsToggledForSite] = useState(true);
  const [minLPsizeValue, setMinLPsizeValue] = useState("");
  const [maxLPsizeValue, setMaxLPsizeValue] = useState("");
  const [isToggledForLP, setIsToggledForLP] = useState(true);
  const [villageCountData, setVillageCountData] = useState(tableData);
  const [activeSortKey, setActiveSortKey] = useState(null);

  const [changeArrowColor, setChangeArrowColor] = useState({
      village: false,
      total_sites: false,
      gov_sites: false,
      total_land_parcel: false,
      government_land_parcel: false
    });

  const toggleBox = (configType) => {
    if (configType === "siteSize") {
      setSiteSizeVisibility(!siteSizeVisibility);
    }

    if (configType === "landParcelSize") {
      setLandParcelSizeVisibility(!landParcelSizeVisibility);
    }
    setError("");
  };

  // Toggle "Select All" functionality
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedVillages([]);
    } else {
      const allVillages = tableData.map((data) => data.village);
      setSelectedVillages(allVillages);
    }
    setSelectAll(!selectAll);
  };

  // Handle individual checkbox selection
  const handleCheckboxChange = (village) => {
    setSelectedVillages((prev) =>
      prev.includes(village)
        ? prev.filter((v) => v !== village)
        : [...prev, village]
    );
  };
  const { getAccessTokenSilently } = useAuth0();

  const columns = [
    {
      width: 12,
      label: "Village",
      dataKey: "village",
      dataType: "text",
    },
    {
      width: 12,
      label: "Sites",
      dataKey: "total_sites",
      dataType: "text",
    },
    {
      width: 12,
      label: "Govt Sites",
      dataKey: "gov_sites",
      dataType: "text",
    },
    {
      width: 12,
      label: "Plots",
      dataKey: "total_land_parcel",
      dataType: "text",
    },
    {
      //width: 15,
      width: 12,
      label: "Govt Plots",
      dataKey: "government_land_parcel",
      dataType: "text",
    },
  ];

  const filterConfig = [
    {
      name: "Village Name",
      type: "village",
      filterType: "search",
    },
    // {
    //   name: "ZONE",
    //   type: "zone",
    // },
    {
      name: "Site SIZE",
      type: "siteSize",
      filterType: "size",
    },
    {
      name: "Land Parcel SIZE",
      type: "landParcelSize",
      filterType: "size",
    },
    {
      name: "SITE REPORT",
      type: "site",
      filterType: "report",
    },
    {
      name: "LAND PARCEL REPORT",
      type: "land",
      filterType: "report",
    },
  ];

  const handleDropdownClick = (configType) => {
    console.log("configType ", configType, " handleDropdownClick ");
    if (configType === "zone") {
      setZonesDropdownVisibility(!zonesDropdownVisibility);
      // setSiteSizeVisibility(false);
      // setLandParcelSizeVisibility(false);
    } else if (configType === "siteSize") {
      // setSiteSizeVisibility(!siteSizeVisibility);
      // setLandParcelSizeVisibility(false);
      setZonesDropdownVisibility(false);
    } else if (configType === "landParcelSize") {
      // setLandParcelSizeVisibility(!landParcelSizeVisibility);
      // setSiteSizeVisibility(false);
      setZonesDropdownVisibility(false);
    }
  };

  const handleZoneClick = (zone) => {
    if (zone === selectAllOptions) {
      const curValue = selectedWorkersZone[zone];
      const tempObj = {};
      for (let key in selectedWorkersZone) {
        tempObj[key] = !curValue;
      }
      dispatch(selectWorkerZone(tempObj));
    } else {
      const tempObj = {};
      tempObj[zone] = true;

      if (
        selectedWorkersZone[zone] === null ||
        selectedWorkersZone[zone] === true
      ) {
        tempObj[zone] = false;
      }

      dispatch(selectWorkerZone(tempObj));
    }
  };

  const handleSearchInput = (val) => {
    setSearchInput(val);
  };

  const dropdownRefs = useRef([]);

  const handleCloseDropdownRef = (dropdown, index) => {
    console.log("handleCloseDropdownRef", dropdown);
    console.log(dropdownRefs);
    return (e) => {
      // alert("this is dropdown blur --- "+ dropdown+ index)
      if (dropdownRefs.current[index].contains(e.relatedTarget)) {
        return;
      }

      handleDropdownClick(dropdown);
    };
  };

  const handleSubmit = (configType) => {
    if (configType === "siteSize") {
      if (!minSiteSizeValue || !maxSiteSizeValue) {
        setError("Please enter both Min and Max values.");
        return;
      }

      if (parseInt(minSiteSizeValue) > parseInt(maxSiteSizeValue)) {
        setError("Max value cannot be smaller than Min value.");
        return;
      }

      if (parseInt(minSiteSizeValue) < 0 || parseInt(maxSiteSizeValue) < 0) {
        setError("Enter value greater than zero.");
        return;
      }
      console.log("Site Min:", minSiteSizeValue, "Site Max:", maxSiteSizeValue);
      if (isToggledForSite) {
        setSiteSizeVisibility(!siteSizeVisibility);
        dispatch(
          setSelectMinMaxOfSize([
            minSiteSizeValue,
            maxSiteSizeValue,
            lpGlobalMinVal,
            lpGlobalMaxVal,
          ])
        );
      }
      setError("");
    }
    if (configType === "landParcelSize") {
      if (!minLPsizeValue || !maxLPsizeValue) {
        setError("Please enter both Min and Max values.");
        return;
      }

      if (parseInt(minLPsizeValue) > parseInt(maxLPsizeValue)) {
        setError("Max value cannot be smaller than Min value.");
        return;
      }

      if (parseInt(minLPsizeValue) < 0 || parseInt(maxLPsizeValue) < 0) {
        setError("Enter value greater than zero.");
        return;
      }
      console.log(" LP Min:", minLPsizeValue, "LP Max:", maxLPsizeValue);
      if (isToggledForLP) {
        setLandParcelSizeVisibility(!landParcelSizeVisibility);
        dispatch(
          setSelectMinMaxOfSize([
            siteGlobalMinVal,
            siteGlobalMaxVal,
            minLPsizeValue,
            maxLPsizeValue,
          ])
        );
      }
      setError("");
    }
  };

  const handleToggle = (configType) => {
    if (configType === "siteSize") {
      setIsToggledForSite((prev) => !prev);
      console.log(
        `Site Toggle button clicked: ${!isToggledForSite ? "ON" : "OFF"}`
      );
      if (isToggledForSite) {
        dispatch(
          setSelectMinMaxOfSize([
            parseInt(minSize),
            parseInt(maxSize),
            lpGlobalMinVal,
            lpGlobalMaxVal,
          ])
        );
      }
    }
    if (configType === "landParcelSize") {
      setIsToggledForLP((prev) => !prev);
      console.log(
        ` LP Toggle button clicked: ${!isToggledForLP ? "ON" : "OFF"}`
      );
      if (isToggledForLP) {
        dispatch(
          setSelectMinMaxOfSize([
            siteGlobalMinVal,
            siteGlobalMaxVal,
            parseInt(minSize),
            parseInt(maxSize),
          ])
        );
      }
    }
  };

  const fetchVillageCount = async (
    callback,
    minSiteSize = siteGlobalMinVal,
    maxSiteSize = siteGlobalMaxVal,
    minLPsize = lpGlobalMinVal,
    maxLPsize = lpGlobalMaxVal
  ) => {
    dispatch(setApplicationLoading(true));
    try {
      const accessToken = await getAccessTokenSilently({
        authorizationParams: {
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        },
      });

      const url = `${process.env.REACT_APP_API_BASE_URL}/get_village_count?minSiteSize=${minSiteSize}&maxSiteSize=${maxSiteSize}&minLPsize=${minLPsize}&maxLPsize=${maxLPsize}`;
      console.log("village Count url ", url);
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        dispatch(setApplicationLoading(false));
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      callback(data);
      dispatch(setApplicationLoading(false));
    } catch (error) {
      console.error("Error: Something went wrong", error);
      dispatch(setApplicationLoading(false));
    }
  };

  const handleShowSaveReportSidebar = (reportType) => {
    dispatch(
      manipulateVerticalSidebar({
        ...verticalSidebar,
        showSidebar: true,
        data: {
          takeInput: true,
          header: "Consolidated Report",
          description: "This is a consolidated report",
          footer: {
            label: "Save Report",
            onClick: (data) => {
              saveReportUsingAPI(data, reportType);
            },
          },
        },
      })
    );
  };

  const saveReportUsingAPI = async (data, reportType) => {
    dispatch(setApplicationLoading(true));
    console.log("report type ", reportType);
    const accessToken = await getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      },
    });
    if (reportType === "site") {
      helperFunctions.saveSitesReportUsingAPI(accessToken, data, (res, err) => {
        if (err) {
          alert("Error in saving report");
          console.log("Something went wrong !");
          dispatch(setApplicationLoading(false));
          return;
        }

        dispatch(
          manipulateVerticalSidebar({
            ...verticalSidebar,
            showSidebar: true,
            data: {
              ...verticalSidebar.data,
              sheetLink: res,
              takeInput: false,
              header: "Consolidated Report",
            },
          })
        );

        dispatch(setApplicationLoading(false));
      });
    } else {
      helperFunctions.saveLPReportUsingAPI(accessToken, data, (res, err) => {
        if (err) {
          alert("Error in saving report");
          console.log("Something went wrong !");
          dispatch(setApplicationLoading(false));
          return;
        }

        dispatch(
          manipulateVerticalSidebar({
            ...verticalSidebar,
            showSidebar: true,
            data: {
              ...verticalSidebar.data,
              sheetLink: res,
              takeInput: false,
              header: "Consolidated Report",
            },
          })
        );

        dispatch(setApplicationLoading(false));
      });
    }
  };

  const handleSortButtonClick = (headerType) => {
    const sortedData = [...tableData].sort(
      (a, b) => b[headerType] - a[headerType]
    ); // descending
    setVillageCountData(sortedData);
    setActiveSortKey(headerType);
    console.log("village Count data ", villageCountData);
    setChangeArrowColor({
      ...changeArrowColor,
      village: false,
      total_sites: false,
      gov_sites: false,
      total_land_parcel: false,
      government_land_parcel: false,
      [headerType]: !changeArrowColor[headerType],
    });
  };

  useEffect(() => {
    console.log("Selected Villages list ", selectedVillages);
    dispatch(fetchSelectedVillages(selectedVillages));
  }, [selectedVillages]);

  useEffect(() => {
    console.log("*******fetchVillageCount**********");

    fetchVillageCount(
      (data) => {
        dispatch(fetchVillageCountDetailsSuccess(data));
      },
      siteGlobalMinVal,
      siteGlobalMaxVal,
      lpGlobalMinVal,
      lpGlobalMaxVal
    );
    setVillageCountData({})
    setChangeArrowColor({
      village: false,
      total_sites: false,
      gov_sites: false,
      total_land_parcel: false,
      government_land_parcel: false
    });
  }, [siteGlobalMinVal, siteGlobalMaxVal, lpGlobalMinVal, lpGlobalMaxVal]);

  return (
    <div className="table-container">
      <div className="filters-section">
        <div className="filters-left-section">
          {filterConfig.map((config, index) => (
            <div
              key={filterConfig.type}
              className="filters-button-container"
              onBlur={handleCloseDropdownRef(config.type, index)}
              ref={(el) => (dropdownRefs.current[index] = el)}
              tabIndex={80 + index}
            >
              <h5 className="filters-dropdown-label">
                <Translate text={config.name} />
              </h5>

              {config.filterType === "search" ? (
                <div className="search-site-id">
                  <TextField
                    id="search-site-id"
                    placeholder={
                      user.language !== "hi"
                        ? "Search by Village...."
                        : "गांव के नाम से खोजें"
                    }
                    type="search"
                    fullWidth
                    defaultValue=""
                    focused
                    onInput={(evt) => handleSearchInput(evt.target.value)}
                    InputProps={
                      <Icon
                        baseClassName="fas"
                        className={"fa fa-magnifying-glass"}
                        fontSize="small"
                        color="var(--secondary-text-color)"
                        style={{ color: "var(--secondary-text-color)" }}
                      />
                    }
                  />
                </div>
              ) : config.filterType === "size" ? (
                <div
                  className="filters-dropdown-container-box"
                  style={{ position: "relative" }} // Ensure the parent div has relative positioning
                  onClick={() => {
                    handleDropdownClick(config.type);
                    //toggleBox();
                  }}
                >
                  <Button
                    onClick={() => {
                      toggleBox(config.type);
                    }}
                    variant="contained"
                    style={{
                      borderRadius: "0.75rem",
                      background: "var(--bg-color)",
                      color: "var(--text-color)",
                      padding: "1rem",
                      width: "12rem",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    className="filters-button"
                  >
                    <FilterListIcon
                      titleAccess="Filter"
                      className="container-icon"
                      fontSize="small"
                    />
                    <p
                      className="filters-button-p"
                      style={{ textTransform: "none" }}
                    >
                      <Translate text="SIZE(sqmtr)" />
                    </p>
                    <KeyboardArrowDownIcon
                      titleAccess="Expand"
                      fontSize="small"
                    />
                  </Button>

                  {config.type === "siteSize" && siteSizeVisibility && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        zIndex: 10,
                        mt: 1,
                        p: 2,
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "white",
                        boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                        minWidth: "10rem",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 2,
                          justifyContent: "space-between",
                          //width: "100%",
                        }}
                      >
                        <TextField
                          label="Min Size"
                          type="number"
                          variant="outlined"
                          value={minSiteSizeValue}
                          onChange={(e) => setMinSiteSizeValue(e.target.value)}
                          sx={{ flex: 1 }} // Responsive width
                        />
                        <TextField
                          label="Max Size"
                          type="number"
                          variant="outlined"
                          value={maxSiteSizeValue}
                          onChange={(e) => setMaxSiteSizeValue(e.target.value)}
                          sx={{ flex: 1 }} // Responsive width
                        />
                      </Box>

                      {error && (
                        <FormHelperText sx={{ color: "red", mb: 2 }}>
                          {error}
                        </FormHelperText>
                      )}
                      <Box
                        mt={2}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          width: "100%",
                          gap: 2,
                        }}
                      >
                        {/* Submit Button */}
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: "grey",
                            color: "white",
                            "&:hover": { backgroundColor: "black" },
                            height: "1.5rem",
                            width: "5rem", // Reduced width
                          }}
                          onClick={() => {
                            handleSubmit(config.type);
                          }}
                        >
                          Submit
                        </Button>

                        {/* Toggle Button */}
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: isToggledForSite ? "blue" : "grey",
                            color: "white",
                            "&:hover": {
                              backgroundColor: isToggledForSite
                                ? "darkblue"
                                : "black",
                            },
                            height: "1.5rem",
                            width: "3rem", // Reduced width
                          }}
                          onClick={() => {
                            handleToggle(config.type);
                          }}
                        >
                          {/* {isToggledForSite ? "ON" : "OFF"} */}
                          {"RESET"}
                        </Button>
                      </Box>
                    </Box>
                  )}

                  {config.type === "landParcelSize" &&
                    landParcelSizeVisibility && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          zIndex: 10,
                          mt: 1,
                          p: 2,
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          backgroundColor: "white",
                          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                          minWidth: "10rem",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 2,
                            justifyContent: "space-between",
                            //width: "100%",
                          }}
                        >
                          <TextField
                            label="Min Size"
                            type="number"
                            variant="outlined"
                            value={minLPsizeValue}
                            onChange={(e) => setMinLPsizeValue(e.target.value)}
                            sx={{ flex: 1 }} // Responsive width
                          />
                          <TextField
                            label="Max Size"
                            type="number"
                            variant="outlined"
                            value={maxLPsizeValue}
                            onChange={(e) => setMaxLPsizeValue(e.target.value)}
                            sx={{ flex: 1 }} // Responsive width
                          />
                        </Box>

                        {error && (
                          <FormHelperText sx={{ color: "red", mb: 2 }}>
                            {error}
                          </FormHelperText>
                        )}
                        <Box
                          mt={2}
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            gap: 2,
                          }}
                        >
                          {/* Submit Button */}
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "grey",
                              color: "white",
                              "&:hover": { backgroundColor: "black" },
                              height: "1.5rem",
                              width: "5rem", // Reduced width
                            }}
                            onClick={() => {
                              handleSubmit(config.type);
                            }}
                          >
                            Submit
                          </Button>

                          {/* Toggle Button */}
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: isToggledForLP ? "blue" : "grey",
                              color: "white",
                              "&:hover": {
                                backgroundColor: isToggledForLP
                                  ? "darkblue"
                                  : "black",
                              },
                              height: "1.5rem",
                              width: "3rem", // Reduced width
                            }}
                            onClick={() => {
                              handleToggle(config.type);
                            }}
                          >
                            {/* {isToggledForSite ? "ON" : "OFF"} */}
                            {"RESET"}
                          </Button>
                        </Box>
                      </Box>
                    )}
                </div>
              ) : config.filterType === "report" ? (
                <div
                  className="row gap-1"
                  onClick={() => {
                    handleShowSaveReportSidebar(config.type);
                  }}
                >
                  <Icon
                    title="Save Report"
                    baseClassName={"fas"}
                    className={"cursor-pointer fa-file-arrow-down"}
                    fontSize="small"
                  />

                  {/* <h5 className="m-0 cursor-pointer">
                    <Translate text={"Save Report"} />
                  </h5> */}
                </div>
              ) : (
                <div className="filters-dropdown-sub-container">
                  <div
                    className="filters-dropdown-selected-label"
                    onClick={() => handleDropdownClick(config.type)}
                  >
                    <p>
                      <Translate text={"Selected"} />
                    </p>

                    <Icon
                      baseClassName={"fas"}
                      className={"cursor-pointer fa-caret-down"}
                      fontSize="small"
                    />
                  </div>

                  <div>
                    <div
                      className={
                        "status-select-dropdown" +
                        (config.type === "zone" && zonesDropdownVisibility
                          ? ""
                          : " hide") +
                        (config.type === "zone"
                          ? " zone-filter-dropdown-container"
                          : "")
                      }
                    >
                      {config.type === "zone" &&
                        zones.map((zone) => {
                          return (
                            <div
                              className="site-info-status-select-sub-container cursor-pointer"
                              style={{ color: zone.color }}
                              onClick={() => handleZoneClick(zone)}
                            >
                              <Checkbox
                                onChange={(evt) =>
                                  handleZoneClick(
                                    selectedWorkersZone[zone],
                                    zone
                                  )
                                }
                                checked={selectedWorkersZone[zone] === true}
                              />

                              <p className="m-0" style={{ flexGrow: 1 }}>
                                <Translate text={zone} />
                              </p>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Table starts from here */}
      <div className="table-sub-container">
        <div
          className="row table-header"
          style={{
            padding: "0" /* Remove internal padding */,
            margin: "0" /* Remove any margin */,
          }}
        >
          <div style={{ width: "5%", maxWidth: "5%" }}>
            <Button
              variant="contained"
              color={selectAll ? "error" : "primary"}
              startIcon={selectAll ? <Cancel /> : <CheckCircle />}
              onClick={handleSelectAll}
              sx={{
                height: "3rem",
                borderRadius: "1rem", // More rounded corners
                textTransform: "none", // Prevents uppercase text
                fontSize: "1rem", // Adjust font size
              }}
            >
              {selectAll ? "DESELECT" : "SELECT"}
            </Button>
          </div>
          {columns.map((val) => (
            <div
              key={val.dataKey}
              style={{
                width: val.width + "%",
                maxWidth: val.width + "%",
                overflow: "hidden",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "4px" }}
              >
                <h4 style={{ margin: 0 }}>
                  <Translate text={val.label} />
                </h4>
                <span
                  className="sort-icon"
                  style={{
                    backgroundColor:
                      activeSortKey === val.dataKey
                        ? changeArrowColor[val.dataKey]
                          ? "red"
                          : "#1493ed"
                        : "#1493ed",
                  }}
                  onClick={() => handleSortButtonClick(val.dataKey)}
                >
                  {changeArrowColor[val.dataKey] && activeSortKey === val.dataKey ? (
                    <ArrowUp size={16} />
                  ) : (
                    <ArrowDown size={16} />
                  )}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="data-row-container">
          {(villageCountData?.length > 0 ? villageCountData : tableData).map(
            (data, index) => {
              if (
                //          selectedWorkersZone[data.zone] &&
                searchInput === "" ||
                data?.village
                  .toString()
                  .toLowerCase()
                  .includes(searchInput.toLowerCase())
              ) {
                return (
                  <div className="row data-row" key={index}>
                    <p className="m-0" style={{ width: "5%", maxWidth: "5%" }}>
                      <input
                        type="checkbox"
                        checked={selectedVillages.includes(data.village)}
                        onChange={() => handleCheckboxChange(data.village)}
                      />
                    </p>
                    {columns.map((column) => (
                      <p
                        className="m-0"
                        style={{
                          width: column.width + "%",
                          maxWidth: column.width + "%",
                        }}
                      >
                        <Translate text={data[column.dataKey]} />
                      </p>
                    ))}
                  </div>
                );
              }
            }
          )}
        </div>
      </div>

      {/* Add Field Member Icon */}
      {/* <div
        className="add-circle-container"
        style={{
          position: "absolute",
          top: "2rem",
          right: "7rem",
        }}
        onClick={() => {
          setShowModal(true)
          setType("")
          setmodalHeader("Enter New Member Details")
        }}
      >
        <Icon
          baseClassName="fas"
          className="fa fa-plus"
          fontSize="medium"
        />
      </div>
      {showModal && (
        <div className="modal-container">
          <AddModal
            fieldMembersdata={fieldmember}
            modaltypes={type}
            showModal={showModal}
            setShowModal={setShowModal}
            modalHeader={modalHeader}
          />
        </div>
      )} */}
    </div>
  );
};

export default TableComponent;
